import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TransitionFormInstances } from '../../models/site-metadata/transition-form-instances.model';
import { UserWorkflowTransition } from '../../models/site-metadata/user-workflow-transition.model';
import { UserWorkflowTransitionService } from '../../services/user-bulk-workflow.service';
import { FormInstance } from '../../models/site-content/form-instance.model';
import { AlertDialogComponent, AlertDialogModel } from '../alert/alert-dialog.component';

export class BulkWorkflowDialogInitData {
    public formInstanceIds: number[] = null;

    public constructor(public isMultiTemplateFormsGrid, public formTemplateId: number = 0, public formsGridFormFieldId: number = -1) {
    }
}

@Component({
    selector: 'app-bulk-workflow',
    templateUrl: './bulk-workflow.dialog.html',
    styleUrls: ['./bulk-workflow.dialog.scss'],
    standalone: false
})
export class BulkWorkflowDialog implements OnInit {

    private selectedWorkflowTransitionId: number;
    private userWorkflowTransitions: UserWorkflowTransition[];
    private ngFormGroup: UntypedFormGroup;
    private transitionCompleted: boolean = false;
    private transitionedFormInstances: FormInstance[];

    public constructor(
        @Inject(MAT_DIALOG_DATA) public data: BulkWorkflowDialogInitData,
        private fb: UntypedFormBuilder,
        private userWorkflowService: UserWorkflowTransitionService,
        private dialogRef: MatDialogRef<BulkWorkflowDialog>,
        private dialog: MatDialog
    ) { }

    // Life cycle methods.
    public ngOnInit(): void {
        this.ngFormGroup = this.fb.group({
            transitionSelect: this.selectedWorkflowTransitionId,
            dirty: false
        });

        if (this.data.isMultiTemplateFormsGrid) {
            this.userWorkflowService.multiTemplateFormsGridFormInstancesReferenceCommonWorkflow(this.data.formsGridFormFieldId, this.data.formInstanceIds).then(response => {
                if (response == true) {
                    this.userWorkflowService.getMultiTemplateUserAvailableWorkflowTransitions(this.data.formsGridFormFieldId, this.data.formInstanceIds).then(transitions => {
                        this.userWorkflowTransitions = transitions;
                        if (this.userWorkflowTransitions.length == 1) {
                            this.selectedWorkflowTransitionId = this.userWorkflowTransitions[0].workflowTransitionId;
                        }
                        else {
                            this.selectedWorkflowTransitionId = -1;
                        }
                    });
                } else {
                    // Display an error message indicating that the selected form instance Ids refer to form templates that use different workflows.
                    this.dialog.open(AlertDialogComponent, {
                        maxWidth: "600px",
                        data: new AlertDialogModel("Different Workflows", "The selected forms are governed by more than one workflow and cannot be transitioned together.  Please change the forms selected and try again.")
                    });
                }
            });
        } else {
            this.userWorkflowService.getUserAvailableWorkflowTransitions(this.data.formTemplateId).then(x => {
                this.userWorkflowTransitions = x;
                if (this.userWorkflowTransitions.length == 1) {
                    this.selectedWorkflowTransitionId = this.userWorkflowTransitions[0].workflowTransitionId;
                }
                else {
                    this.selectedWorkflowTransitionId = -1;
                }
            });
        }
    }

    // Handle control events.
    public onSave() {
        let tfi: TransitionFormInstances = new TransitionFormInstances();
        tfi.workflowTransitionId = this.selectedWorkflowTransitionId;
        tfi.formInstanceIds = this.data.formInstanceIds;
        tfi.formsGridFormFieldId = this.data.formsGridFormFieldId;

        this.userWorkflowService.transitionFormInstances(tfi).then(response => {
            this.transitionedFormInstances = response;
            this.transitionCompleted = true;
        })
    }

    // Getters/Setters
    public get NgFormGroup(): UntypedFormGroup {
        return this.ngFormGroup;
    }
    public get UserWorkflowTransitions(): UserWorkflowTransition[] {
        return this.userWorkflowTransitions;
    }
    public get SelectedWorkflowTransitionId(): number {
        return this.selectedWorkflowTransitionId;
    }
    public set SelectedWorkflowTransitionId(selectedWorkflowTransitionIdParam: number) {
        this.selectedWorkflowTransitionId = selectedWorkflowTransitionIdParam;
    }
    public get OKDisabled(): boolean {
        return ((this.selectedWorkflowTransitionId == null) || (this.selectedWorkflowTransitionId < 0));
    }
    public get TransitionCompleted(): boolean {
        return this.transitionCompleted;
    }
    public get TransitionedFormInstances(): FormInstance[] {
        return this.transitionedFormInstances;
    }
}
